// Vendor imports
const Immutable = require('immutable')
// Client lib imports
const globalPageContext = require('client/lib/business-events/page-context')
// Common Client V2 imports
const {
  defaultReviver,
  keyedReviver
} = require('client-v2/common/state/revivers')
// Sibling imports
const LocationRecord = require('./location')

class PageHistoryRecord extends Immutable.Record({
  location: null,
  pageContext: null,
  title: String()
}) {
  static fromWindowLocation() {
    const { pathname, search, hash } = window.location
    return this.fromJS({
      location: { pathname, search, hash },
      pageContext: globalPageContext.getPageContext(),
      title: document.title
    })
  }

  static fromJS(state) {
    return Immutable.fromJS(state, reviver)
  }

  isWindowLocation() {
    return this.equals(PageHistoryRecord.fromWindowLocation())
  }

  applyPageContext() {
    if (this.pageContext) {
      globalPageContext.setPageContext(this.pageContext.toJS())
    }
  }

  revertPageContext() {
    if (this.pageContext) {
      globalPageContext.revertPageContext(this.pageContext.toJS())
    }
  }

  applyTitle() {
    document.title = this.title
  }

  pushState() {
    /**
     * This cannot update `app.history` because it would
     * break the router for the page behind the modal.
     */
    window.history.pushState(null, '', this.location.href)
    this.applyTitle()
    this.applyPageContext()
  }

  replaceState() {
    /**
     * This cannot update `app.history` because it would
     * break the router for the page behind the modal.
     */
    window.history.replaceState(null, '', this.location.href)
    this.applyTitle()
    this.applyPageContext()
  }
}

const reviver = keyedReviver(PageHistoryRecord, {
  location: LocationRecord.reviver,
  pageContext: defaultReviver
})

module.exports = Object.assign(PageHistoryRecord, {
  reviver
})
